<template lang='pug'>
#App 
  router-view
</template>
<script>
export default {
  name: "App",
};
</script>